import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../../field.interface";


@Component({
  selector: "app-select",
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})

export class SelectComponent implements OnInit {
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  field: FieldConfig;
  group: FormGroup;
  constructor() { }
  ngOnInit() { }  

  onChange($event) {
    this.change.emit($event)
  }
}